import { LX_DEFAULT_VALUE } from "../components/dictation/Lexical/utils/lexicalValue";
import { QueryKeys } from "../constants/queryKeys";
import { queryClient } from "../queryClient";
import { Reference } from "../types/reference";
import { generateHumanDisplayName } from "../utils/DataTransformationUtils";

export const CarePlansManager = {
  invalidate: () =>
    queryClient.invalidateQueries({ queryKey: [QueryKeys.CARE_PLANS] }),

  createDefault(
    carePlan: string,
    patientReference: Reference,
    encounterReference: Reference,
    organizationReference: Reference,
  ) {
    const carePlanValue = LX_DEFAULT_VALUE;
    carePlanValue.root.children[0].children[0].text = carePlan;
    const carePlanDescription = JSON.stringify(carePlanValue);

    return {
      status: "draft",
      intent: "plan",
      category: [],
      title: `${generateHumanDisplayName(patientReference.display)}'s Care Plan`,
      description: carePlanDescription,
      subject: patientReference,
      encounter: encounterReference,
      addresses: [],
      activity: [],
      note: [],
      managingOrganization: organizationReference,
    };
  },
};
